import { supabase } from "./supabase"

// interface User {
//   access_token: string
//   id: string
// }

class AdminApiService {
  private baseUrl: string
  
  constructor() {
    this.baseUrl = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/admin-words`
  }


  private async makeRequest(endpoint: string, options: RequestInit = {}): Promise<any> {
    const response = await fetch(`${this.baseUrl}/${endpoint}`, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${await AdminApiService.getAuthToken()}`,
        ...options.headers
      }
    })

    const data = await response.json()
    
    if (!response.ok) {
      throw new Error(data.error || `API request failed: ${response.status}`)
    }

    return data
  }

  async getPendingWords(page: number = 1, perPage: number = 50, status: string = 'all') {
    return this.makeRequest(`pending?page=${page}&per_page=${perPage}&status=${status}`)
  }

  async getWordStats() {
    return this.makeRequest('stats')
  }

  async generateWords(request: {
    count: number
    difficultyLevel: number
    ageGroup: string
    category?: string
    customPrompt?: string
  }) {
    return this.makeRequest('generate', {
      method: 'POST',
      body: JSON.stringify(request)
    })
  }

  async generateBatchWords(requests: Array<{
    count: number
    difficultyLevel: number
    ageGroup: string
    category?: string
    customPrompt?: string
  }>) {
    return this.makeRequest('generate-batch', {
      method: 'POST',
      body: JSON.stringify({ words: requests })
    })
  }

  async createManualWord(word: {
    word: string
    phoneticTranscription?: string
    definition: string
    exampleSentence?: string
    difficultyLevel: number
    ageGroup: string
    category?: string
  }) {
    return this.makeRequest('manual', {
      method: 'POST',
      body: JSON.stringify(word)
    })
  }

  async approveWords(wordIds: string[]) {
    return this.makeRequest('approve', {
      method: 'POST',
      body: JSON.stringify({ wordIds })
    })
  }

  async rejectWords(wordIds: string[], rejectionReason?: string) {
    return this.makeRequest('reject', {
      method: 'POST',
      body: JSON.stringify({ wordIds, rejectionReason })
    })
  }

  async getGenerationProgress() {
    return this.makeRequest('progress')
  }

  /**
   * Get authentication token from Supabase
   */
  private static async getAuthToken(): Promise<string> {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session?.access_token) {
      throw new Error('No authentication token available');
    }
    return session.access_token;
  }
}

export const adminApi = new AdminApiService()
export default adminApi
